import { render, staticRenderFns } from "./accodion-item.vue?vue&type=template&id=40444454&scoped=true"
import script from "./accodion-item.vue?vue&type=script&lang=js"
export * from "./accodion-item.vue?vue&type=script&lang=js"
import style0 from "./accodion-item.vue?vue&type=style&index=0&id=40444454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40444454",
  null
  
)

export default component.exports